<template>
  <v-container class="ma-0 pa-2 customscroll" center="start" style="height: 100%" fluid>
    <v-dialog hide-overlay v-model="modalDeclaration" style="width: 0px; height: 0px" width="0px" height="0px">
      <v-card ref="refDeclarationDialogContent"></v-card>
    </v-dialog>

    <v-dialog hide-overlay v-model="modalPreviewDeclaration" :width="declarationWidth + 18" :style="'width: ' + declarationWidth + 'px; height: ' + declarationHeight + 'px;'">
      <v-card class="ma-0 pa-0" style="width: 100%; height: 100%">
        <v-container v-if="currentClient" class="elevation-3" :style="isInDarkMode ? 'background-color: #363636;' : '' + 'overflow: hidden; width: ' + declarationWidth + 'px;'">
          <v-row justify="center">
            <t-button btnText="Изтегли" btnIcon="mdi-download" @click.native="download()" />
            <v-spacer></v-spacer>
            <t-button btnText="Затвори" btnIcon="mdi-close-octagon" :btnColor="'red'" :iconLeft="false" @click.native="modalPreviewDeclaration = false" />
            <!-- <t-button btnText="Качи файл с подписана декларация" :btnDisabled="isSaveDisabled" btnIcon="mdi-upload" @click.native="$refs.refUpoadDeclaration.click()" /> -->
          </v-row>
          <v-container class="a4border" color="white" align="center" justify="center" ref="refDeclarationContent" :style="'overflow: hidden; width: ' + declarationWidth + 'px; height: ' + declarationHeight + 'px;'">
            <br />
            <v-row align="center" justify="center">
              <p class="title" style="white-space: nowrap">Декларация</p>
            </v-row>
            <br />
            <br />
            <v-row align="center" justify="center">
              <p style="width: 100%; text-align: center">За получаване на данните от производителя на ФУ</p>
            </v-row>
            <br />
            <br />
            <br />
            <v-row align="center" justify="center">
              <v-col>
                <v-row class="ma-0 pa-0" v-if="currentClient">
                  <!-- <p slot="prepend" class="text-no-wrap" v-if="user">Долуподписаният: {{ user.firstName + " " + user.middleName + " " + user.lastName }}</p> -->
                  <p slot="prepend" class="text-no-wrap pr-2" v-if="user">{{ "Долуподписаният: " + currentClient.userFullName }}</p>
                </v-row>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col>
                <p>в качеството си на ползвател на Фискални Устройства (ФУ) със серийни номера и регистрационни данни, както следва:</p>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-data-table :mobile-breakpoint="0" disable-sort disable-pagination style="width: 90%" dense fluid class="ma-0 pa-0 elevation-0" :headers="devTableHeaders" :items="currentClient.devs" item-key="eik" hide-default-footer />
            </v-row>
            <v-row align="center" justify="center">
              <v-col>
                <!-- <p class="subtitle-2">
                <i>Попълнете минимум един ред от таблицата. Ако представлявате няколко фирми попълнете устройства за различните фирми.</i>
              </p> -->
                <p class="title-3">и представляващ фирма/и:</p>
              </v-col>
            </v-row>
            <v-row align="center" justify="center" style="overflow: hidden">
              <v-data-table :mobile-breakpoint="0" disable-sort disable-pagination style="width: 90%" dense fluid class="ma-0 pa-0 elevation-0" :headers="firmTableHeaders" :items="currentClient.firms" hide-default-footer />
            </v-row>
            <v-row align="center" justify="center">
              <v-col>
                <p>съм съгласен да получавам данни за принадлежащите ми ФУ от производител ТРЕМОЛ ООД, съгласно чл. 15а от Наредба № Н-18 за регистриране и отчитане чрез фискални устройства на продажбите в търговските обекти.</p>
              </v-col>
            </v-row>
            <v-row align="center" justify="center" v-if="user.eik != currentClient.eik">
              <v-col>
                <p>{{ "Съгласен съм да предоставя достъп до данните си на потребител с ЕИК " + user.eik }}.</p>
                <p>{{ "Достъпът може да бъде преустановен по всяко време, чрез изпращане на следния код до assistant@tremol.bg: " + currentClient.removeCode }}.</p>
              </v-col>
            </v-row>
            <v-row align="start" justify="center">
              <v-col cols="4">
                <p>{{ "Дата: " + new Date().toTremolFpStringShort() }}</p>
              </v-col>
              <!-- <v-col cols="3">
              <v-dialog ref="caldendarDialogRef" v-model="modalCalendar" :return-value.sync="date" persistent width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field :dark="false" v-on="on" maxlength="10" height="17" dense fluid color="default" :value="new Date(date).toTremolFpStringShort()"></v-text-field>
                </template>
                <v-date-picker firstDayOfWeek="1" type="date" locale="bg" v-model="date">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modalCalendar = false">Отказ</v-btn>
                  <v-btn text color="primary" @click="$refs.caldendarDialogRef.save(date)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col> -->
              <v-col cols="6" align="end" justify="end">
                <p>Декларатор: __________________</p>
              </v-col>
            </v-row>
            <v-row align="center" justify="end" class="ma-0 pa-0">
              <v-col cols="9" class="ma-0 pa-0"></v-col>
              <v-col cols="3" class="ma-0 pa-0">
                <p>/ Подпис /</p>
              </v-col>
            </v-row>
            <v-row align="center" justify="end" class="ma-0">
              <v-col cols="9" class="ma-0 pa-1"></v-col>
              <v-col cols="3" class="ma-0 pa-1">
                <p>/ Печат /</p>
              </v-col>
            </v-row>
          </v-container>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editDialog" v-if="editDialog" width="unset" height="auto" persistent transition="nice-modal-fade">
      <v-card width="400" class="ma-0pa-0">
        <v-form ref="refRegisterNewForm" lazy-validation class="pt-1">
          <v-alert type="info" class="ma-2" dense dismissible>
            <span>Моля, попълнете и проверете всички данни за фирмата</span>
          </v-alert>
          <br />
          <template v-for="(h, idx) in clientsheaders2">
            <v-row class="ma-0 pa-0 pa-3 pt-1" v-if="h.proptype != proptype.None && h.proptype != proptype.BOOL" :key="idx" align="center" justify="center">
              <v-text-field class="ma-0 pa-0" v-model="selectedFirm[h.value]" :label="h.text" :rules="[rules.required]"> </v-text-field>
            </v-row>
          </template>
        </v-form>
        <v-row class="ma-0 pa-0 pa-0 pb-3" align="center" justify="end">
          <t-button v-if="clients.length > 1" :class="'ma-1'" btnText="Откажи" btnIcon="mdi-minus-circle" style="width: 150px" @click.native="closeEditDialog(false)" />
          <t-button btnText="Запази" :class="'ma-1'" btnIcon="mdi-checkbox-marked-circle-outline" style="width: 150px" @click.native="closeEditDialog(true)" />
        </v-row>
      </v-card>
    </v-dialog>

    <v-row class="ma-0 pa-0">
      <v-alert type="info" class="ma-2 pa-2" :class="isOnMobile ? '' : 'mr-8'" dense dismissible>
        <span class="my-1 subtitle-2"
          >Във връзка с измененията на Наредба Н-18 от 02.07.2019 г. е необходимо да ни бъде предоставена декларация от клиента, че желае да си получава данните от ФУ. Декларацията може да бъде електронно подписана с фирмен електронен подпис и качена в приложението TREMOL Assistant или да се завери нотариално и оригинален хартиен носител да бъде изпратен до офиса на фирма ТРЕМОЛ ООД (гр. Велико
          Търново, ул. Толедо 6, търговски отдел).</span
        >
      </v-alert>
      <div class="" style="width: 100%" v-if="user && user.approved">
        <v-row class="ma-0 pa-0" align="center" justify="center"><span class="subtitle-1">Списък с одобрени фирми</span> </v-row>
      </div>
      <v-form style="min-width: 100%" v-if="user && user.approved">
        <v-data-table class="ma-2 pa-0 elevation-3" title="Списък с одобрени фирми" hide-default-footer :items="getClients" :headers="clientsheaders" fluid single-expand fixed-header disable-pagination>
          <!-- <template v-slot:no-data>
          <v-row class="ma-0 pa-0" align="center" justify="center">
            <v-alert :value="true" color="default" icon="mdi-emoticon-sad">{{ error_message != null ? error_message : "Няма данни за показване" }}</v-alert>
          </v-row>
        </template> -->
          <template v-for="(h, index) in clientsheaders" v-slot:[`item.${h.value}`]="{ item }">
            <span :key="index" class="data-grid-cell" :style="h.cell_align == 'center' ? 'justify-content: center;' : 'justify-content: flex-' + h.cell_align + ';'">
              {{ formatGridData(h.proptype, Object.byString(item, h.value)) }}
            </span>
          </template>
        </v-data-table>
      </v-form>

      <div v-if="getNewClients.length > 0" class="" style="width: 100%">
        <v-row class="ma-0 pa-0" align="center" justify="center"><span class="subtitle-1">Списък с нови, все още неодобрени фирми</span> </v-row>
      </div>
      <v-form v-if="getNewClients.length > 0" style="min-width: 100%" ref="refFirmsForm">
        <v-data-table class="ma-2 pa-0 elevation-3" title="Списък с неодобрени фирми" hide-default-footer :items="getNewClients" :headers="clientsheaders2" fluid single-expand fixed-header disable-pagination>
          <!-- <template v-slot:no-data>
          <v-row class="ma-0 pa-0" align="center" justify="center">
            <v-alert :value="true" color="default" icon="mdi-emoticon-sad">{{ error_message != null ? error_message : "Няма данни за показване" }}</v-alert>
          </v-row>
        </template> -->

          <template v-for="(h, index) in clientsheaders2" v-slot:[`item.${h.value}`]="{ item }">
            <span :key="index" class="data-grid-cell" :style="h.cell_align == 'center' ? 'justify-content: center;' : 'justify-content: flex-' + h.cell_align + ';'">
              {{ formatGridData(h.proptype, Object.byString(item, h.value)) }}
            </span>
          </template>
          <template v-slot:[`item.editDeclaration`]="{ item }">
            <v-icon v-if="item.eik != user.eik" @click="editFirm(item)">mdi-pencil</v-icon>
          </template>
          <template v-slot:[`item.deleteFirm`]="{ item }">
            <v-icon v-if="item.eik != user.eik" @click="deleteFirm(item)">mdi-minus-circle</v-icon>
          </template>
          <template v-slot:[`item.downloadDeclaration`]="{ item }">
            <v-icon v-if="!item.isApproved && objectHasNoNulls(item)" @click="showDeclaration(item.eik)">mdi-download</v-icon>
          </template>
          <template v-slot:[`item.uploadSignedDeclaration`]="{ item }">
            <input style="visibility: hidden; width: 2px" type="file" :ref="'refUpoadDeclaration' + item.eik" class="custom-file-input" @change="uploadSignedDeclaration($event, item.eik)" accept="application/pdf" />
            <v-icon v-if="objectHasNoNulls(item) && !isSaveDisabled" @click="$refs['refUpoadDeclaration' + item.eik].click()">mdi-upload</v-icon>
          </template>
        </v-data-table>
      </v-form>

      <v-row class="ma-2 pa-0" :class="isOnMobile ? '' : ' box-container-horizontal'" align="center">
        <div class="row-header">
          <t-button btnText="Добави нова фирма" :class="'ma-1'" btnIcon="mdi-plus-circle" @click.native="addNewFirm()" />
        </div>
        <div v-if="!isOnMobile" class="row-content"></div>
        <div class="row-header" v-if="getNewClients.length > 0">
          <t-button v-if="getNewClients.length > 1" btnText="Преглед на обща декларация" btnIcon="mdi-download" @click.native="showDeclaration()" />
        </div>
      </v-row>
      <v-row class="ma-2 pa-2" v-if="getNewClients.length > 1">
        <span style="font-style: italic">Ако нямате електронен подпис или предпочитате да заверите декларация нотариално и да ни я изпратите по пощата или по куриер, можете да го направите с една обща декларация за всички Ваши фирми.</span>
      </v-row>
    </v-row>
    <div id="dpi"></div>
  </v-container>
</template>

<script>
import DataManager, { ErrorMessage, DataHeader, DataPropType } from "../../js/DataManager";
// eslint-disable-next-line no-unused-vars
import domtoimage from "dom-to-image";
import jsPDF from "jspdf";
//import verifyPDF from "pdf-signature-reader";
//import RobotoFont from "../assets/fonts/Roboto";

class DeclarationData {
  constructor() {
    this.isNew = true;
    this.userFullName = "";
    //this.userEGN = "";
    this.firmName = "";
    this.eik = "";
    this.deviceSN = "";
    this.deviceFDRID = "";
    this.date = new Date();
    this.isNew = true;
    this.removeCode = "";
  }
}

export default {
  components: {},
  data() {
    return {
      editDialog: false,
      selectedFirm: null,
      tempFirm: null,
      proptype: DataPropType,
      formatGridData: DataManager.formatGridData,
      isSaveDisabled: false,
      datatype: null,
      declarationWidth: 0,
      declarationHeight: 0,
      modalCalendar: false,
      modalDeclaration: false,
      modalPreviewDeclaration: false,
      date: new Date().toStringWithFormat("yyyy-MM-dd"),
      devTableHeaders: [new DataHeader("№", "number", DataPropType.Number, "center"), new DataHeader("Индивидуален № на ФУ", "deviceSN", DataPropType.String, "center"), new DataHeader("FDRID", "deviceFDRID", DataPropType.String, "center")],
      firmTableHeaders: [new DataHeader("№", "number", DataPropType.Number, "center"), new DataHeader("Име на фирма", "firmName", DataPropType.String, "center"), new DataHeader("ЕИК", "eik", DataPropType.String, "center")],
      clientsheaders: [
        new DataHeader("Име на фирма", "firmName", DataPropType.String),
        new DataHeader("ЕИК на фирма", "eik", DataPropType.String),
        // new DataHeader("МОЛ (три имена)", "userFullName", DataPropType.String),
        new DataHeader("Сериен номер на ФУ", "deviceSN", DataPropType.String),
        new DataHeader("FDRID на ФУ", "deviceFDRID", DataPropType.String),
      ],
      clientsheaders2: [
        new DataHeader("Име на фирма", "firmName", DataPropType.String),
        new DataHeader("ЕИК на фирма", "eik", DataPropType.String),
        new DataHeader("МОЛ (три имена)", "userFullName", DataPropType.String),
        new DataHeader("Сериен номер на ФУ", "deviceSN", DataPropType.String),
        new DataHeader("FDRID на ФУ", "deviceFDRID", DataPropType.String),
        new DataHeader("Качена е декларация", "isDeclarationSent", DataPropType.BOOL, "center"),
        new DataHeader("Изтегли декларация", "downloadDeclaration", DataPropType.None),
        new DataHeader("Качи подписана декларация", "uploadSignedDeclaration", DataPropType.None),
        new DataHeader("Редакция", "editDeclaration", DataPropType.None),
        new DataHeader("Изтриване", "deleteFirm", DataPropType.None),
      ],
      expanded: [],
      user: null,
      clients: [],
      currentClient: null,
      error_message: null,
      rules: {
        required: (v) => (!!v || "Задължително поле") && (v.length >= 2 || "Невалидна стойност"),
      },
    };
  },
  methods: {
    setTitleAndData(meta, error) {
      this.datatype = meta.datatype;
      this.clients = [];
      this.$nextTick(() => {
        var dpi = document.getElementById("dpi");
        this.declarationWidth = dpi.offsetWidth * 21;
        this.declarationHeight = dpi.offsetHeight * 29.7;
        this.modalDeclaration = false;
      });

      this.user = DataManager.getData(DataManager.DataType.user);
      var allDevs = DataManager.getData(DataManager.DataType.devices, true).filter((d) => !!d.fdrid);

      if (error.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
        var firms = DataManager.getData(DataManager.DataType.clients, true);

        var allFirms = firms
          .map((f) => ({
            eik: f.eik,
            mol: f.mol,
            approved: true,
          }))
          .unique();
        // var uniqueEiks = allDevs
        //   .map(function (f) {
        //     return f.client.eik;
        //   })
        //   .unique();

        allFirms.forEach((firm) => {
          var dev = allDevs.find((dev) => dev.client.eik == firm.eik);
          if (dev) {
            var dd = new DeclarationData();
            dd.userFullName = dev.client.mol || firm.mol;
            dd.firmName = dev.client.orgName;
            dd.eik = dev.client.eik;
            dd.deviceSN = dev.sn;
            dd.deviceFDRID = dev.fdrid;
            dd.isApproved = firm.approved;
            dd.isDeclarationSent = true;
            this.clients.push(dd);
          }
        });
      } else {
        this.error_message = error.Message;
        //this.dialogLoader.showError(error.Message, { location: "center" });
        var dd = new DeclarationData();
        dd.userFullName = allDevs[0].client.mol || this.user.firstName + "  " + this.user.middleName + " " + this.user.lastName;
        dd.firmName = this.user.orgName || allDevs[0].client.orgName;
        dd.eik = this.user.eik;
        dd.deviceSN = allDevs[0].sn;
        dd.deviceFDRID = allDevs[0].fdrid;
        dd.isApproved = false;
        dd.isDeclarationSent = false;
        if (this.user.settings1.isDeclarationSent) {
          dd.isDeclarationSent = true;
        }
        dd.isNew = false;
        dd.removeCode = "Не можеш да премахнеш себе си?";
        this.clients.push(dd);

        this.selectedFirm = dd;

        if (!this.objectHasNoNulls(dd)) {
          this.editDialog = true;
          // this.$nextTick(() => {
          //   this.dialogLoader.showInfo("За да генерирате декларация, моля попълнете всички данни за фирмата.", { timeout: 5000, location: "center" });
          // });
        } else {
          this.$nextTick(() => {
            this.showDeclaration(this.selectedFirm.eik);
          });
        }
      }
      try {
        var newClients = null;
        if (!this.user.settings2 || !(this.user.settings2 instanceof Object)) {
          this.user.settings2 = {};
        } else if (this.user.settings2 instanceof Array) {
          newClients = this.user.settings2;
        } else if (this.user.settings2 instanceof Object && this.user.settings2.clients) {
          newClients = this.user.settings2.clients;
        }
        if (newClients) {
          var oldClients = this.clients.filter((c) => c.isApproved);
          newClients = newClients.filter((c) => oldClients.filter((oc) => oc.eik == c.eik).length == 0);
          this.clients.push(...newClients);
        }
      } catch {
        //ignored
      }
    },
    objectHasNoNulls(f) {
      return f.userFullName != "" && f.deviceSN != "" && f.deviceFDRID != "" && f.orgName != "" && f.eik != "" && f.removeCode != "";
    },
    editFirm(item) {
      if (item.eik == this.user.eik) {
        this.dialogLoader.showInfo("Не може да редактирате основната фирма.");
      } else {
        this.selectedFirm = item;
        this.selectedFirm.isNew = false;
        this.tempFirm = Object.assign({}, this.selectedFirm);
        this.editDialog = true;
      }
    },
    addNewFirm() {
      //this.dialogLoader.showInfo("Във връзка с измененията на Наредба Н-18 от 02.07.2019 г. е необходимо да ни бъде предоставена декларация от клиента, че желае да си получава данните от ФУ. Декларацията трябва да бъде електронно подписана от собственика на ФУ или да бъде изпратен нотариално заверен оригинален хартиен носител.", { location: "center" });
      var c = new DeclarationData();
      this.clients.push(c);
      this.selectedFirm = c;
      this.tempFirm = Object.assign({}, this.selectedFirm);
      this.editDialog = true;
    },
    deleteFirm(firm) {
      this.dialog.show(
        "yes-no",
        null,
        {
          title: "Потвърждение",
          buttonYesText: "Да",
          buttonNoText: "Не",
          text: "Сигурни ли сте, че искате да изтриете фирмата?",
        },
        (result) => {
          if (result) {
            this.clients.splice(this.clients.indexOf(firm), 1);
            this.saveAddedFirms();
          }
        },
      );
    },
    closeEditDialog(save) {
      if (save) {
        if (!this.$refs.refRegisterNewForm.validate()) {
          this.dialogLoader.showError("Непълни данни!", { location: "center" });
          return;
        } else if (this.clients.filter((c) => c.eik == this.selectedFirm.eik).length > 1) {
          this.dialogLoader.showError("Посочената фирма е вече добавена!", { location: "center" });
          return;
        } else {
          this.dialog.show("loader", null, { message: "Проверка на фирма, моля, изчакайте..." }).then(() => {
            DataManager.getRemoveCode(this.selectedFirm.eik, this.selectedFirm.deviceSN, this.selectedFirm.deviceFDRID, async (err) => {
              this.dialog.close().then(() => {
                if (err.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
                  this.selectedFirm.removeCode = DataManager.getData(DataManager.DataType.remove_code, true);
                  this.editDialog = false;
                  this.saveAddedFirms();
                  this.showDeclaration(this.selectedFirm.eik);
                } else {
                  this.dialogLoader.showError("Грешка при заявка за проверка на фирма.\n" + err.Message, { location: "center" });
                }
              });
            });
          });
        }
      } else {
        Object.assign(this.selectedFirm, this.tempFirm);
        if (this.selectedFirm.isNew) {
          this.clients.splice(this.clients.length - 1, 1);
        }
        this.editDialog = false;
      }
    },
    saveAddedFirms() {
      this.user.settings2.clients = this.clients.filter((c) => !c.isApproved && c.eik != this.user.eik);
      //cc.forEach((c) => delete c.userEGN);
      DataManager.updateUserSettings(this.user.settings1, this.user.settings2);
    },
    showDeclaration(eik) {
      if (!this.$refs.refFirmsForm || !this.$refs.refFirmsForm.validate()) {
        return;
      }
      const cltz = this.getNewClients.filter((c) => !eik || c.eik == eik);
      if (cltz.length > 0 && cltz.map((c) => c.userFullName).unique().length > 1) {
        this.dialogLoader.showError("Фирмите в списъка имат различни собственици!", { location: "center" });
        return;
      }
      //console.log(cltz);
      this.currentClient = {
        eik: cltz[0].eik,
        userFullName: cltz[0].userFullName,
        removeCode: cltz[0].removeCode,
        devs: [],
        firms: [],
      };
      var ix = 0;
      cltz.forEach((c) => {
        this.currentClient.devs.push({ number: ++ix, deviceSN: c.deviceSN, deviceFDRID: c.deviceFDRID });
        this.currentClient.firms.push({ number: ix, firmName: c.firmName, eik: c.eik });
      });
      this.$nextTick(() => {
        this.modalPreviewDeclaration = true;
      });
    },
    download() {
      this.$nextTick(() => {
        this.modalDeclaration = true;
        var vm = this;
        this.$nextTick(() => {
          this.$refs.refDeclarationContent.setAttribute("style", "max-width: " + this.declarationWidth + "px; min-width: " + this.declarationWidth + "px; width: " + this.declarationWidth + "px; height: " + this.declarationHeight + "px;");
          /** @type {Node} */
          const obj = vm.$refs.refDeclarationContent.cloneNode(true);
          vm.setDeclarationClass(obj);
          vm.$refs.refDeclarationDialogContent.$el.append(obj);
          vm.$refs.refDeclarationDialogContent.$el.setAttribute("style", "width: " + vm.declarationHeight + 10 + "px; height: " + vm.declarationHeight + "px;");
          domtoimage
            .toPng(obj)
            .then(function (dataUrl) {
              let img = new Image();
              img.src = dataUrl;
              const doc = new jsPDF({
                orientation: "portrait",
                unit: "mm",
                //format: "a4",
                format: [210, 297],
              });
              doc.addImage(img, "PNG", 0, 0);

              // doc.addFileToVFS("Roboto-Regular.ttf", RobotoFont.base64);
              // doc.addFont("Roboto-Regular.ttf", "Roboto-Regular", "normal");
              // doc.setFont("Roboto-Regular"); // set font

              doc.save(vm.currentClient.userFullName + "_DeclarationTremol.pdf", { returnPromise: true }).then(function () {
                vm.modalDeclaration = false;
                vm.$refs.refDeclarationDialogContent.$el.removeChild(obj);
              });
            })
            .catch((error) => {
              vm.dialogLoader.showError(error);
            });
        });
      });
    },
    setDeclarationClass(node) {
      if (node.nodeType == 1) {
        node.setAttribute("class", "declaration " + node.getAttribute("class"));
        node.setAttribute("style", "color: black;" + node.getAttribute("style"));
      }
      if (node.hasChildNodes()) {
        node.childNodes.forEach((n) => {
          if (n.nodeType == 1) {
            this.setDeclarationClass(n);
          }
        });
      }
    },
    uploadSignedDeclaration(e, eik) {
      const file = e.target.files[0];
      let reader = new FileReader();
      reader.onload = () => {
        try {
          this.isSaveDisabled = true;
          let arrayBuffer = new Uint8Array(reader.result);
          if (window.document.documentMode) {
            throw Error("Декларацията не е подписана с електронен подпис!");
          } else {
            require("pdf-signature-reader")(reader.result);
          }
          var result = arrayBuffer.toBase64string();
          var o = { base64EncodedFile: result, clientToBeAddedEIK: eik };
          DataManager.updateUserSignedDeclaration(o, (error) => {
            if (error.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
              this.dialogLoader.showInfo("Декларацията е изпратена успешно.\nЩе получите съобщение в уведомителната система когато декларацията бъде одобрена.");
              var f = this.clients.find((c) => c.eik == eik);
              if (f) {
                f.isDeclarationSent = true;
                if (eik == this.user.eik) {
                  this.user.settings1.isDeclarationSent = true;
                }
              }
              this.saveAddedFirms();
            } else {
              this.dialogLoader.showError(error.Message);
            }
            setTimeout(() => {
              this.isSaveDisabled = false;
              this.$refs.refUpoadDeclaration.value = "";
            }, 3000);
          });
        } catch (ex) {
          this.dialogLoader.showError("Грешка при изпращане на декларация: " + ex.message);
          setTimeout(() => {
            this.isSaveDisabled = false;
            this.$refs.refUpoadDeclaration.value = "";
          }, 3000);
          return;
        }
      };
      reader.readAsArrayBuffer(file);
    },
    save() {},
    cancel() {},
    open() {},
    close() {},
  },
  computed: {
    getClients() {
      return this.clients.filter((c) => c.isApproved);
    },
    getNewClients() {
      return this.clients.filter((c) => !c.isApproved);
    },
  },
  mounted() {},
};
</script>
<style scoped>
#dpi {
  height: 1cm;
  left: -100%;
  position: absolute;
  top: -100%;
  width: 1cm;
}

.a4border {
  padding-left: 2cm;
  padding-right: 1.5cm;
  padding-top: 1.5cm;
  padding-bottom: 1.5cm;
}

.declaration,
.declaration >>> v-input__slot {
  border-color: gray;
  color: black;
  background-color: white;
}
</style>